/**
 * PoweredBy - ссылка "Powered by ShiftGears" под строкой ввода
 *
 * Отображается внизу чат-панели как брендинговая ссылка.
 */

import { memo } from 'react';
import arrowBrandSvg from '../../assets/icons/ArrowBrand.svg';
import { WidgetLink } from './WidgetLink';
import { t } from './translations';
import { languagePropType } from './utils/propTypes';
import './PoweredBy.css';

const SHIFTGEARS_URL = 'https://shiftgears.ai';

export const PoweredBy = memo(({ language = 'en' }) => {
  return (
    <div className="powered-by">
      <WidgetLink href={SHIFTGEARS_URL} variant="muted" className="powered-by__link">
        <img src={arrowBrandSvg} width={8} height={8} alt="" />
        {/* «Powered by» на языке витрины (#1431); бренд не переводится. */}
        {t('poweredBy', language)} ShiftGears
      </WidgetLink>
    </div>
  );
});

PoweredBy.displayName = 'PoweredBy';

PoweredBy.propTypes = {
  language: languagePropType,
};
